import {SVGProps} from "react";

// Download tray from the V2 sidebar app row (Figma "Icon / Download", 78:635).
export const DownloadSvg = ({color = '#E4BD79', ...props}: SVGProps<SVGSVGElement>) => (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden {...props}>
        <path d="M9 2.25V11.25M12 8.25L9 11.25L6 8.25M3.75 12V15H14.25V12" stroke={color} strokeWidth="1.275"
              strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
)
